module.exports = __webpack_public_path__ + "static/img/glbig02.198a5332.jpg";